import React from 'react';

import { StyleSheet, Text, View } from '@react-pdf/renderer';

import { format } from './../format';
import { withTranslate } from '../../../../../core/TenantProvider';

const styles = StyleSheet.create({
  customAttributes: {
    display: 'flex',
    flexDirection: 'row'
  },
  paymentState: {
    fontWeight: 'bold',
    margin: '0 3px'
  },
  paymentAccrued: {
    alignItems: 'center',
    display: 'flex',
    fontSize: '8px'
  },
  tableCell: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    fontSize: '10px',
    justifyContent: 'center',
    padding: '6px 7px'
  },
  tableCellAlternative: {
    backgroundColor: '#FAFAFA'
  },
  valueContainer: {
    display: 'flex',
    flexDirection: 'row',

  },
  wide: {
    flex: 2
  }
});

export const TableCell = (props: any) => {
  const {
    alternative,
    children,
    field,
    wide,
    translate
  } = props;

  let tableCellStyle = {
    ...styles.tableCell
  };

  if (alternative) {
    tableCellStyle = {
      ...tableCellStyle,
      ...styles.tableCellAlternative
    }
  }

  if (wide) {
    tableCellStyle = {
      ...tableCellStyle,
      ...styles.wide
    };
  }

  let value: any = children;

  if (field) {
    value = (
      <View style={styles.valueContainer}>
        <Text>{field.fieldValuePrefix ? field.fieldValuePrefix : ''}{format(field)}</Text>
        {field.customAttributes !== undefined && (
          <View style={styles.customAttributes}>
            {field.customAttributes.paid && (
              <Text style={styles.paymentState}>
                {translate('pdf.account.statement.paid.label')}
              </Text>
            )}
            {/* <Text style={styles.paymentAccrued}>
              ({field.customAttributes.currency}{numeral(field.customAttributes.accrued).format('0,0.00')} Balance)
            </Text> */}
          </View>
        )}
      </View>
    );
  }

  return (
    <View style={tableCellStyle}>
      {value}
    </View>
  )
};

export default withTranslate(
  (TableCell)
);